import guest from "@/middleware/guest";

export default [
    {
        path: "termos_tribanco",
        name: "termos_tribanco",
        meta: { middleware: [guest] },
        component: () => import("./TermosTribanco")
    }
];
